/** App-wide TanStack Query keys (project dashboard + admin user list). */

export const userKey = () => ['hatsuly', 'user'] as const

// `userId` is set when an admin views another user's dashboard (via `?user_id=`), so that
// user's lists cache separately from the admin's own.
export const ownedProjectsKey = (userId?: string) => ['hatsuly', 'ownedProjects', userId ?? null] as const

export const invitedProjectsKey = (userId?: string) => ['hatsuly', 'invitedProjects', userId ?? null] as const

export const inspectionAreasKey = (projectId: string) => ['hatsuly', 'inspectionAreas', projectId] as const

export const inspectionSheetKey = (projectId: string, inspectionAreaId: string) =>
  ['hatsuly', 'inspectionSheet', projectId, inspectionAreaId] as const

export const featureFlagsKey = () => ['hatsuly', 'featureFlags'] as const

/** Root key for the admin user list — used to invalidate every page/filter after a save. */
export const userListRootKey = () => ['hatsuly', 'userList'] as const

export const userListKey = (params: {
  email: string
  /** Sort direction, or undefined when the list is left unsorted. */
  sortDir?: string
  limit: number
  lastEvaluatedKey?: Record<string, string>
}) =>
  [...userListRootKey(), params.email, params.sortDir ?? null, params.limit, params.lastEvaluatedKey ?? null] as const
